var map = {
	"./en-GB.json": [
		9962,
		9962
	],
	"./en-NL.json": [
		54765,
		4765
	],
	"./fr-BE.json": [
		67827,
		7827
	],
	"./nl-BE.json": [
		40413,
		413
	],
	"./nl-NL.json": [
		97810,
		7810
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45873;
module.exports = webpackAsyncContext;